import { isEmpty } from 'lodash';

const getGroupStoresResponse = (data) => {
    if (isEmpty(data)) return [];

    const { page_data } = data;

    const mappingData = page_data?.map((item) => {
        return {
            id: item?.group,
            name: item?.group,
        };
    });

    return mappingData;
};

export default getGroupStoresResponse;
